import { useSelector } from 'react-redux';
import TStore from '../types/store';
import { useMemo } from 'react';

const CZ_PREFIX = '+420';
const ENG_PREFIX = '+421';
const SK_PREFIX = '+421';

export default function usePhonePrefix() {
  const currentLang: any = useSelector((store: TStore) => store.app.currentLang);

  return useMemo(() => {
    switch (currentLang) {
      case 'cs':
        return CZ_PREFIX;
      case 'sk':
        return SK_PREFIX;
      default:
        return '';
    }
  }, [currentLang]);
}

export function usePhonePrefixSecret() {
  const currentLang: any = useSelector((store: TStore) => store.app.currentLang);

  return useMemo(() => {
    switch (currentLang) {
      case 'cs':
        return `${CZ_PREFIX}*** *** ***`;
      case 'sk':
        return `${SK_PREFIX}*** *** ***`;
      default:
        return `${ENG_PREFIX}*** *** ***`;
    }
  }, [currentLang]);
}
